// Checkout Cart Snippet JavaScript
console.log("Checkout cart snippet JS file loaded");
let scrollY = window.scrollY;

// ============================================================================
// UPCART API INTEGRATION
// ============================================================================
// Initialize cart instances array
if (!window.checkoutCartInstances) {
  window.checkoutCartInstances = [];
}

// Store reference to sync all checkout cart instances
window.syncAllCheckoutCartInstances = function() {
  console.log('UpCart: Syncing all checkout cart instances');
  
  if (window.checkoutCartInstances && window.checkoutCartInstances.length > 0) {
    window.checkoutCartInstances.forEach(function(instance) {
      console.log('Syncing checkout cart instance:', instance.cartId);
      setTimeout(function() {
        instance.syncFunction();
      }, 100);
    });
  } else {
    console.log('No checkout cart instances registered yet');
  }
};

// Wait for both DOM to load AND for header.liquid callbacks to be set up
// Then wrap the callbacks to add our checkout cart sync functionality
window.addEventListener('DOMContentLoaded', function() {
  console.log('Checkout cart: Waiting for header.liquid UpCart callbacks to initialize...');
  
  // Use setTimeout to ensure header.liquid's DOMContentLoaded handler runs first
  setTimeout(function() {
    console.log('Checkout cart: Setting up UpCart callback wrappers');
    
    // Store original callbacks from header.liquid
    const originalCartUpdated = window.upcartOnCartUpdated;
    const originalAddToCart = window.upcartOnAddToCart;
    const originalItemRemoved = window.upcartOnItemRemoved;
    
    console.log('Original callbacks found:', {
      cartUpdated: typeof originalCartUpdated,
      addToCart: typeof originalAddToCart,
      itemRemoved: typeof originalItemRemoved
    });
    
    // Called by UpCart when the cart is updated (single parameter: cart object)
    window.upcartOnCartUpdated = function(cart) {
      console.log('UpCart: Cart updated callback triggered', 'Cart:', cart);
      
      // Call original header.liquid callback first
      if (originalCartUpdated && typeof originalCartUpdated === 'function') {
        console.log('Calling original header.liquid cartUpdated callback');
        originalCartUpdated(cart);
      }
      
      // Sync checkout cart instances
      window.syncAllCheckoutCartInstances();
    };
    
    // Called by UpCart when an item is added to cart (single parameter: cart object)
    window.upcartOnAddToCart = function(cart) {
      console.log('UpCart: Item added to cart callback triggered', 'Cart:', cart);
      
      // Call original callback if exists
      if (originalAddToCart && typeof originalAddToCart === 'function') {
        console.log('Calling original header.liquid addToCart callback');
        originalAddToCart(cart);
      }
      
      // Sync checkout cart instances
      window.syncAllCheckoutCartInstances();
    };
    
    // Called by UpCart when an item is removed from cart (single parameter: cart object)
    window.upcartOnItemRemoved = function(cart) {
      console.log('UpCart: Item removed from cart callback triggered', 'Cart:', cart);
      
      // Call original callback if exists
      if (originalItemRemoved && typeof originalItemRemoved === 'function') {
        console.log('Calling original header.liquid itemRemoved callback');
        originalItemRemoved(cart);
      }
      
      // Sync checkout cart instances
      window.syncAllCheckoutCartInstances();
    };
    
    // Store original selling plan callback if exists
    const originalSelectUpsellItemSellingPlan = window.upcartSelectUpsellItemSellingPlan;
    
    // Called by UpCart when a selling plan is changed (one-time vs subscription)
    window.upcartSelectUpsellItemSellingPlan = function(cart, item, sellingPlanId) {
      console.log('UpCart: Selling plan changed', 'Cart:', cart, 'Item:', item, 'Selling Plan ID:', sellingPlanId);
      
      // Call original callback if exists
      if (originalSelectUpsellItemSellingPlan && typeof originalSelectUpsellItemSellingPlan === 'function') {
        console.log('Calling original upcartSelectUpsellItemSellingPlan callback');
        originalSelectUpsellItemSellingPlan(cart, item, sellingPlanId);
      }
      
      // Sync checkout cart instances to update prices and subscription status
      console.log('Syncing checkout cart after selling plan change');
      window.syncAllCheckoutCartInstances();
    };
    
    console.log('UpCart API callback wrappers installed successfully (including selling plan changes)!');
  }, 500); // Wait 500ms to ensure header.liquid callbacks are set
});
// ============================================================================

// Make function globally accessible
window.initCheckoutCartSnippet = function(cartId) {
  // Get current cart total (this would normally come from Shopify cart API)
  let currentCartTotal = 0; // Start with 0
  let cartItems = []; // Array to store cart items
  let isInitialized = false; // Flag to prevent multiple initialization calls
  let isInitialSync = true; // Flag to prevent auto-expand during initial cart sync
  let hasSyncedBefore = false; // Flag to track if we've completed a sync before
  let isBatchUpdatingDisplay = false;
  let pendingDisplayUpdate = false;
  let pendingAddFeedback = false;
  const stickyCartElement = document.querySelector('.checkout-cart-sticky-' + cartId);
  const fixedCartElement = document.querySelector('.checkout-cart-fixed-' + cartId);
  const fixedCartCheckoutButton = fixedCartElement ? fixedCartElement.querySelector('.btn-checkout-' + cartId) : null;
  const defaultFixedCheckoutHref = fixedCartCheckoutButton ? fixedCartCheckoutButton.getAttribute('href') : null;
  const toggleArrowUpSvg = '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"> \
                              <path d="M1 11L10 2L19 11" stroke="#BDBDBD" stroke-width="1.63636"/> \
                            </svg>';
  const toggleArrowDownSvg = '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"> \
                                <path d="M1 1L10 10L19 1" stroke="#BDBDBD" stroke-width="1.63636"/> \
                              </svg>';
  if (!window.checkoutCartToggleArrowUp) {
    window.checkoutCartToggleArrowUp = toggleArrowUpSvg;
    window.checkoutCartToggleArrowDown = toggleArrowDownSvg;
  }

  const cartBodySelector = '.checkout-cart-body-' + cartId;
  const progressBarSelector = '.progress-bar-' + cartId;
  const discountTiersSelector = '.discount-tiers-' + cartId;
  const cachedCartBodyElement = stickyCartElement?.querySelector(cartBodySelector) || document.querySelector(cartBodySelector);
  const cachedProgressBarElement = stickyCartElement?.querySelector(progressBarSelector) || document.querySelector(progressBarSelector);
  const cachedDiscountTiersContainer = stickyCartElement?.querySelector(discountTiersSelector) || document.querySelector(discountTiersSelector);

  function queueCartDisplayUpdate(includeFeedback) {
    if (isBatchUpdatingDisplay) {
      pendingDisplayUpdate = true;
      if (includeFeedback) {
        pendingAddFeedback = true;
      }
      return;
    }

    updateCartDisplay();
    if (includeFeedback) {
      showAddToCartFeedback();
    }
  }

  function beginDisplayBatchUpdate() {
    isBatchUpdatingDisplay = true;
    pendingDisplayUpdate = false;
    pendingAddFeedback = false;
  }

  function endDisplayBatchUpdate(forceDisplayUpdate) {
    isBatchUpdatingDisplay = false;

    if (forceDisplayUpdate || pendingDisplayUpdate) {
      updateCartDisplay();
    }
    if (pendingAddFeedback) {
      showAddToCartFeedback();
    }

    pendingDisplayUpdate = false;
    pendingAddFeedback = false;
  }
  
  // Default SVG placeholder for empty cart slots - Pouch design
  const defaultProductImage = `<img src="https://cdn.shopify.com/s/files/1/0012/5573/5405/files/image_15.png?v=1759168051" width="50" height="50"></img>`;
  
  // Store original empty slots from Liquid-rendered HTML (initialized once)
  let originalEmptySlots = null;
  function initializeEmptySlots() {
    if (originalEmptySlots === null) {
      const cartBodyElement = cachedCartBodyElement;
      if (cartBodyElement) {
        const allItemElements = Array.from(cartBodyElement.querySelectorAll(`.checkout-cart-item-${cartId}`));
        originalEmptySlots = allItemElements.filter(el => {
          const productName = el.querySelector(`.product-name-${cartId}`);
          const hasSvgPlaceholder = productName && productName.querySelector('svg');
          const isEmptySlot = hasSvgPlaceholder || el.style.visibility === 'hidden' || el.innerHTML.trim() === '';
          return isEmptySlot;
        }).map(el => el.cloneNode(true)); // Clone them for reuse
      }
    }
    return originalEmptySlots;
  }
  
  // Function to clean product name - same logic as product-grid-byob.liquid
  function cleanProductName(productName) {
    if (!productName) return productName;
    
    const removePatterns = [
      ' - All-in-One Shake',
      ' - Shake tout-en-un',
      'Green Superfood Juice - ',
      'Jus de superaliments verts - ',
      ' - Green Apple',
      ' - Pomme verte',
      '- Boisson tout-en-un',
      ' - All-in-One Superfood Shake',
      'Shake de superaliments tout-en-un - ',
      ' - 32g High Protein Shake',
      ' - Boisson hyperprotéinée 32g'
    ];
    
    let cleanedName = productName;
    removePatterns.forEach(pattern => {
      cleanedName = cleanedName.replace(pattern, '');
    });
    
    return cleanedName.trim();
  }    
  
  // Mobile scroll adjustment for cart height
  let lastScrollY = window.scrollY;
  let scrollAdjustmentTimeout;
  
  function handleMobileScrollAdjustment() {
    // Only work on mobile
    if (window.innerWidth > 768) return;
    
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;
    
    if (!stickyCartElement) return;
    
    const isScrollAdjusted = stickyCartElement.classList.contains('scroll-adjusted');
    
    // Clear any existing timeout
    if (scrollAdjustmentTimeout) {
      clearTimeout(scrollAdjustmentTimeout);
    }
    
    // Handle scroll down (positive delta)
    if (scrollDelta > 0) {
      if (!isScrollAdjusted) {
        stickyCartElement.classList.add('scroll-adjusted');
      }
    }
    // Handle scroll up (negative delta) - reset after a delay
    else if (scrollDelta < 0) {
      scrollAdjustmentTimeout = setTimeout(() => {
        if (stickyCartElement.classList.contains('scroll-adjusted')) {
          stickyCartElement.classList.remove('scroll-adjusted');
        }
      }, 500); // 500ms delay before resetting
    }
    
    lastScrollY = currentScrollY;
  }
  
  function updateToggleButtons(isCollapsed) {
    const stickyToggleButtons = document.querySelectorAll('.checkout-cart-sticky-' + cartId + ' .cart-toggle-' + cartId);
    const fixedToggleButtons = document.querySelectorAll('.checkout-cart-fixed-' + cartId + ' .cart-toggle-' + cartId);

    stickyToggleButtons.forEach(button => {
      button.innerHTML = isCollapsed ? toggleArrowUpSvg : toggleArrowDownSvg;
    });

    fixedToggleButtons.forEach(button => {
      button.innerHTML = toggleArrowUpSvg;
    });
  }
  
  // Add mobile scroll adjustment listener
  window.addEventListener('scroll', handleMobileScrollAdjustment, { passive: true });
  window.addEventListener('scroll', updateFixedCartVisibility, { passive: true });
  window.addEventListener('resize', updateFixedCartVisibility);
  updateFixedCartVisibility();
  
  // Mobile touch drag functionality
  let touchStartY = 0;
  let touchStartTime = 0;
  let isDragging = false;
  let dragThreshold = 50; // Minimum drag distance to trigger open/close
  let velocityThreshold = 0.3; // Minimum velocity for quick swipe
  
  function handleTouchStart(e) {
    // Only work on mobile
    if (window.innerWidth > 768) return;
    
    touchStartY = e.touches[0].clientY;
    touchStartTime = Date.now();
    isDragging = false;
  }
  
  function handleTouchMove(e) {
    // Only work on mobile
    if (window.innerWidth > 768) return;
    
    if (!touchStartY) return;
    
    const touchCurrentY = e.touches[0].clientY;
    const deltaY = touchCurrentY - touchStartY;
    
    // Check if this is a significant drag
    if (Math.abs(deltaY) > 10) {
      isDragging = true;
      e.preventDefault(); // Prevent scrolling while dragging
      
      // Add visual feedback during drag
      if (stickyCartElement) {
        // Slight visual feedback - move cart slightly with drag
        const feedbackAmount = Math.min(Math.abs(deltaY) * 0.1, 10);
        if (deltaY < 0) {
          stickyCartElement.style.transform = `translateY(-${feedbackAmount}px)`;
        } else {
          stickyCartElement.style.transform = `translateY(${feedbackAmount}px)`;
        }
      }
    }
  }
  
  function handleTouchEnd(e) {
    // Only work on mobile
    if (window.innerWidth > 768) return;
    
    if (!touchStartY || !isDragging) {
      touchStartY = 0;
      return;
    }
    
    const touchEndY = e.changedTouches[0].clientY;
    const deltaY = touchEndY - touchStartY;
    const deltaTime = Date.now() - touchStartTime;
    const velocity = Math.abs(deltaY) / deltaTime;
    
    const isCollapsed = stickyCartElement && stickyCartElement.classList.contains('cart-collapsed');
    
    // Determine if should open or close based on drag direction and velocity
    const shouldOpen = deltaY < -dragThreshold || (deltaY < 0 && velocity > velocityThreshold);
    const shouldClose = deltaY > dragThreshold || (deltaY > 0 && velocity > velocityThreshold);
    
    if (shouldOpen && isCollapsed) {
      toggleCart(cartId);
    } else if (shouldClose && !isCollapsed) {
      toggleCart(cartId);
    }
    
    // Reset visual feedback
    if (stickyCartElement) {
      stickyCartElement.style.transform = '';
    }
    
    // Reset values
    touchStartY = 0;
    isDragging = false;
  }
  
  // Add touch event listeners to the cart element
  function setupTouchDrag() {
    const cartElement = document.querySelector('.progress-section-' + cartId);
    const cartFooter = document.querySelector('.checkout-cart-footer-' + cartId);
    if (cartElement && cartFooter) {
      cartElement.addEventListener('touchstart', handleTouchStart, { passive: false });
      cartFooter.addEventListener('touchstart', handleTouchStart, { passive: false });
      cartElement.addEventListener('touchmove', handleTouchMove, { passive: false });
      cartFooter.addEventListener('touchmove', handleTouchMove, { passive: false });
      cartElement.addEventListener('touchend', handleTouchEnd, { passive: true });
      cartFooter.addEventListener('touchend', handleTouchEnd, { passive: true });
    }
  }
  
  // Handle window resize for badge repositioning
  window.addEventListener('resize', () => {
    setTimeout(() => {
      updateCartDisplay(); // Recalculate badge positions on window resize
    }, 100);
  });
  
  // OPTIMIZED: Function to add item to cart with minimal logging
  function addItemToCart(itemData) {
    // Check if item already exists
    const existingItemIndex = cartItems.findIndex(item => item.variantId === itemData.variantId);
    
    if (existingItemIndex !== -1) {
      // Update existing item - don't just add quantity, update all properties
      // This is important when selling plan changes (one-time vs subscription)
      cartItems[existingItemIndex].quantity = itemData.quantity || cartItems[existingItemIndex].quantity;
      cartItems[existingItemIndex].price = itemData.price; // Update price (subscription price may differ)
      cartItems[existingItemIndex].sellingPlan = itemData.sellingPlan;
      cartItems[existingItemIndex].isSubscription = itemData.isSubscription || false;
      cartItems[existingItemIndex].name = cleanProductName(itemData.name);
      cartItems[existingItemIndex].image = itemData.image;
      
    } else {
      // Add new item
      const newItem = {
        variantId: itemData.variantId,
        productId: itemData.productId,
        name: cleanProductName(itemData.name),
        image: itemData.image,
        price: itemData.price,
        quantity: itemData.quantity || 1,
        sellingPlan: itemData.sellingPlan,
        isSubscription: itemData.isSubscription || false
      };
      cartItems.push(newItem);
    }
    
    queueCartDisplayUpdate(true);
  }
  
  // OPTIMIZED: Function to remove item from cart with minimal logging
  function removeItemFromCart(variantId) {
    const itemIndex = cartItems.findIndex(item => item.variantId === variantId);
    if (itemIndex !== -1) {
      const removedItem = cartItems[itemIndex];
      cartItems.splice(itemIndex, 1);
      queueCartDisplayUpdate(false);
      window.removeFromMainCart(variantId);
      // On mobile, collapse cart if it becomes empty
      if (window.innerWidth <= 768 && cartItems.length === 0 && stickyCartElement) {
        stickyCartElement.classList.add('cart-collapsed');
        updateToggleButtons(true);
      }
      
      // Replace quantity selector with Add to Cart button in product grid
      if (window.replaceQuantitySelectorWithAddToCart && removedItem.productId) {
        window.replaceQuantitySelectorWithAddToCart(variantId, removedItem.productId);
      }
    }
  }
  
  // OPTIMIZED: Function to calculate cart total with minimal logging
  function calculateCartTotal() {
    const total = cartItems.reduce((total, item) => {
      return total + (item.price * item.quantity);
    }, 0);
    return total;
  }
  
  // Function to calculate cart total excluding subscription items (for discount calculation)
  function calculateCartTotalForDiscount() {
    const total = cartItems.reduce((total, item) => {
      // Skip subscription items when calculating total for discount
      if (item.isSubscription) {
        return total;
      }
      return total + (item.price * item.quantity);
    }, 0);
    return total;
  }
  
  // Function to check if there are any non-subscription items
  function hasNonSubscriptionItems() {
    return cartItems.some(item => !item.isSubscription);
  }
  
  // Function to show visual feedback when item is added
  function showAddToCartFeedback() {
    if (stickyCartElement) {
      // Add a temporary highlight class for visual feedback
      stickyCartElement.classList.add('cart-feedback-highlight');
      
      setTimeout(() => {
        stickyCartElement.classList.remove('cart-feedback-highlight');
      }, 300);
    }
  }

  function updateFixedCartVisibility() {
    if (!fixedCartElement) {
      return;
    }

    if (window.innerWidth <= 768) {
      fixedCartElement.classList.remove('is-visible');
      return;
    }

    if (!stickyCartElement) {
      fixedCartElement.classList.add('is-visible');
      return;
    }

    const rect = stickyCartElement.getBoundingClientRect();
    const stickyBottomAboveViewport = rect.bottom <= 0;

    if (stickyBottomAboveViewport) {
      fixedCartElement.classList.add('is-visible');
    } else {
      fixedCartElement.classList.remove('is-visible');
    }
  }
  
  // OPTIMIZED: Single function to update cart display with batched DOM operations
  function updateCartDisplay() {
    // Skip if not initialized yet (prevents multiple calls during loading)
    if (!isInitialized) {
      return;
    }
    
    // Calculate cart total FIRST (including all items for display)
    currentCartTotal = calculateCartTotal();
    
    // Calculate total for discount calculation (excluding subscription items)
    const discountCartTotal = calculateCartTotalForDiscount();
    const hasNonSubscription = hasNonSubscriptionItems();
    
    // Batch DOM queries - get all elements once
    const progressFillElement = document.getElementById('progress-fill-' + cartId);
    const discountTiersContainer = cachedDiscountTiersContainer;
    const cartBodyElement = cachedCartBodyElement;
    const progressBarElement = cachedProgressBarElement;

    const stickySummaryElements = stickyCartElement ? {
      bagCount: stickyCartElement.querySelector('.bag-count-' + cartId),
      priceContainer: stickyCartElement.querySelector('.price-container-' + cartId),
      basePrice: stickyCartElement.querySelector('.base-price-' + cartId),
      currentPrice: stickyCartElement.querySelector('.current-price-' + cartId),
      checkoutButton: stickyCartElement.querySelector('.btn-checkout-' + cartId)
    } : {};

    const fixedSummaryElements = fixedCartElement ? {
      bagCount: fixedCartElement.querySelector('.bag-count-' + cartId),
      priceContainer: fixedCartElement.querySelector('.price-container-' + cartId),
      basePrice: fixedCartElement.querySelector('.base-price-' + cartId),
      currentPrice: fixedCartElement.querySelector('.current-price-' + cartId),
      checkoutButton: fixedCartElement.querySelector('.btn-checkout-' + cartId)
    } : {};
    
    const totalBags = cartItems.reduce((total, item) => total + item.quantity, 0);
    const currentTier = getCurrentDiscountTier(discountCartTotal);
    
    // Only apply discount if there are non-subscription items
    const discountAmount = hasNonSubscription ? discountCartTotal * (currentTier.discount / 100) : 0;
    
    // Calculate final price: discount applies only to non-subscription items
    // Subscription items always pay full price
    const nonSubscriptionTotal = discountCartTotal;
    const subscriptionTotal = currentCartTotal - discountCartTotal;
    const finalPrice = (nonSubscriptionTotal - discountAmount) + subscriptionTotal;
    
    const maxValue = parseFloat(discountTiersContainer?.getAttribute('data-max-value')) || 200;
    const badgeWidth = 75;

    let progressFillWidth;
    if (progressBarElement) {
      const progressBarWidth = progressBarElement.clientWidth;
      const availableWidth = progressBarWidth - badgeWidth;
      if (discountCartTotal >= maxValue) {
        progressFillWidth = 100;
      } else {
        const progressRatio = discountCartTotal / maxValue;
        progressFillWidth = (progressRatio * availableWidth / progressBarWidth) * 100;
      }
    } else {
      if (discountCartTotal >= maxValue) {
        progressFillWidth = 100;
      } else {
        const progressPercentage = (discountCartTotal / maxValue) * 100;
        const estimatedProgressBarWidth = 400;
        const badgeWidthPercent = (badgeWidth / estimatedProgressBarWidth) * 100;
        progressFillWidth = progressPercentage - (progressPercentage / 100) * badgeWidthPercent;
      }
    }

    const isDesktop = window.innerWidth > 768;
    const bagCountText = totalBags === 0 ? 'Start adding to save and get sipping!' : `Total of ${totalBags} bags`;
    const basePriceValue = `$${currentCartTotal.toFixed(2)}`;
    const finalPriceValue = `$${(finalPrice + 0.005).toFixed(2)}`;

    if (stickyCartElement) {
      if (cartItems.length === 0) {
        stickyCartElement.classList.add('cart-empty');
      } else {
        stickyCartElement.classList.remove('cart-empty');
      }
    }
    
    // Update cart items display
    if (cartBodyElement) {
      // Initialize empty slots if not already done
      const emptySlots = initializeEmptySlots() || [];
      
      const contentFragment = document.createDocumentFragment();
      
      // Render cart items
      cartItems.forEach((item, index) => {
        const itemElement = createCartItemElement(item, index);
        contentFragment.appendChild(itemElement);
        
        // Add separator after each item (except the last one if it's the 3rd item)
        if (index < cartItems.length - 1 && index < 2) {
          const separator = document.createElement('div');
          separator.className = `checkout-cart-item-separator-${cartId}`;
          contentFragment.appendChild(separator);
        }
      });
      
      // Show/hide empty slots based on cart item count
      const remainingSlots = Math.max(0, 3 - cartItems.length);
      for (let i = 0; i < remainingSlots; i++) {
        // Add separator before empty slot if there are cart items
        if (cartItems.length > 0 && i === 0) {
          const separator = document.createElement('div');
          separator.className = `checkout-cart-item-separator-${cartId}`;
          contentFragment.appendChild(separator);
        }
        
        // Show empty slot if available
        if (emptySlots.length > i) {
          // Clone and show empty slot
          const emptySlot = emptySlots[i].cloneNode(true);
          emptySlot.style.display = '';
          emptySlot.style.visibility = '';
          contentFragment.appendChild(emptySlot);
          
          // Add separator after empty slot (except after the last one)
          if (i < remainingSlots - 1) {
            const separator = document.createElement('div');
            separator.className = `checkout-cart-item-separator-${cartId}`;
            contentFragment.appendChild(separator);
          }
        }
      }
      cartBodyElement.replaceChildren(contentFragment);
    }
    
    if (progressFillElement) {
      progressFillElement.style.width = progressFillWidth + '%';
    }

    updateDiscountBadgeStates(discountCartTotal);

    const applySummary = (elements = {}, options = {}) => {
      if (!elements) return;
      const {
        bagCount,
        priceContainer,
        basePrice,
        currentPrice,
        checkoutButton
      } = elements;

      const {
        hideWhenEmptyOnDesktop = false,
        buttonTextWhenEmpty,
        buttonTextWhenItems,
        disableButtonWhenEmpty = false,
        defaultHref,
        hrefWhenItems
      } = options;

      if (bagCount) {
        bagCount.textContent = bagCountText;
        if (hideWhenEmptyOnDesktop && isDesktop) {
          bagCount.style.visibility = cartItems.length === 0 ? 'hidden' : 'visible';
        } else if (hideWhenEmptyOnDesktop) {
          bagCount.style.visibility = '';
        }
      }

      if (priceContainer) {
        if (hideWhenEmptyOnDesktop && isDesktop) {
          priceContainer.style.visibility = cartItems.length === 0 ? 'hidden' : 'visible';
        } else if (hideWhenEmptyOnDesktop) {
          priceContainer.style.visibility = '';
        }
      }

      if (basePrice && currentPrice) {
        if (!hasNonSubscription) {
          basePrice.style.display = 'none';
          currentPrice.textContent = basePriceValue;
          currentPrice.style.color = '#2BA059';
          currentPrice.style.fontWeight = 'bold';
          currentPrice.style.textDecoration = '';
        } else {
          basePrice.textContent = basePriceValue;
          currentPrice.textContent = finalPriceValue;

          if (currentCartTotal === finalPrice) {
            basePrice.style.display = 'none';
            currentPrice.style.color = cartItems.length === 0 ? '#7C7C7C' : '#2BA059';
            currentPrice.style.textDecoration = '';
            currentPrice.style.fontWeight = '';
          } else {
            basePrice.style.display = '';
            currentPrice.style.color = '#2BA059';
            currentPrice.style.fontWeight = currentTier.discount > 0 ? 'bold' : '';
            currentPrice.style.textDecoration = '';
          }
        }
      }

      if (checkoutButton) {
        checkoutButton.dataset.hasItems = totalBags > 0 ? 'true' : 'false';

        if (buttonTextWhenEmpty) {
          checkoutButton.textContent = totalBags === 0 ? buttonTextWhenEmpty : (buttonTextWhenItems || buttonTextWhenEmpty);
        }

        if (disableButtonWhenEmpty && checkoutButton instanceof HTMLButtonElement) {
          checkoutButton.disabled = totalBags === 0;
        }

        if (checkoutButton instanceof HTMLAnchorElement) {
          if (totalBags === 0) {
            if (defaultHref !== null && defaultHref !== undefined) {
              checkoutButton.setAttribute('href', defaultHref);
            } else {
              checkoutButton.removeAttribute('href');
            }
          } else if (hrefWhenItems) {
            checkoutButton.setAttribute('href', hrefWhenItems);
          }
        }
      }
    };

    applySummary(stickySummaryElements, {
      hideWhenEmptyOnDesktop: true,
      buttonTextWhenEmpty: 'Add to cart',
      buttonTextWhenItems: 'Checkout',
      disableButtonWhenEmpty: true
    });

    applySummary(fixedSummaryElements, {
      hideWhenEmptyOnDesktop: false,
      buttonTextWhenEmpty: 'Build Your Cart',
      buttonTextWhenItems: 'Complete Checkout',
      defaultHref: defaultFixedCheckoutHref,
      hrefWhenItems: '#complete-checkout'
    });

    updateFixedCartVisibility();
  }
  
  // REMOVED: updateCheckoutButton() and updatePrices() - now handled in updateCartDisplay()
  
  // Function to update discount badge states (CSS handles positioning)
  function updateDiscountBadgeStates(cartTotalForDiscount) {
    const tierElements = cachedTierElements || document.querySelectorAll(`[id^="tier-"][id$="-${cartId}"]`);
    
    if (tierElements.length === 0) {
      return;
    }
    
    // Use the cart total passed as parameter (excluding subscription items)
    const totalForTier = cartTotalForDiscount !== undefined ? cartTotalForDiscount : currentCartTotal;
    
    tierElements.forEach((tierElement) => {
      const threshold = parseFloat(tierElement.getAttribute('data-threshold')) || 0;
      
      // Update active/inactive state based on cart total (excluding subscriptions)
      if (totalForTier >= threshold) {
        const activeClass = `discount-tier-${cartId} discount-tier-active-${cartId}`;
        if (tierElement.className !== activeClass) {
          tierElement.className = activeClass;
        }
      } else {
        const inactiveClass = `discount-tier-${cartId} discount-tier-inactive-${cartId}`;
        if (tierElement.className !== inactiveClass) {
          tierElement.className = inactiveClass;
        }
      }
    });
  }
  
  // OPTIMIZED: Function to get current discount tier with caching
  let cachedTierElements = null;
  function getCurrentDiscountTier(cartTotalForDiscount) {
    // Cache tier elements to avoid repeated DOM queries
    if (!cachedTierElements) {
      cachedTierElements = document.querySelectorAll(`[id^="tier-"][id$="-${cartId}"]`);
    }
    
    let currentTier = { discount: 0, label: '0% OFF' }; // Default no discount
    
    // Use the cart total passed as parameter (excluding subscription items)
    const totalForTier = cartTotalForDiscount !== undefined ? cartTotalForDiscount : currentCartTotal;
    
    cachedTierElements.forEach(tierElement => {
      const threshold = parseFloat(tierElement.getAttribute('data-threshold')) || 0;
      const percentageText = tierElement.textContent.trim();
      const percentage = parseFloat(percentageText.replace('% OFF', '')) || 0;
      
      if (totalForTier >= threshold && percentage > currentTier.discount) {
        currentTier = { discount: percentage, label: percentageText };
      }
    });
    
    return currentTier;
  }
  
  // REMOVED: updateProgressBar(), updateDiscountTiers(), updateCartItemsDisplay() - now handled in updateCartDisplay()
  
  // Function to create cart item element
  function createCartItemElement(item, index) {
    const itemDiv = document.createElement('div');
    itemDiv.className = `checkout-cart-item-${cartId}`;
    
    // Show price per item with subscription background color if it's a subscription
    const priceDisplayStyle = item.isSubscription 
      ? 'font-size: 11px; color: white; margin-left: 5px; background-color: #2BA059; padding: 2px 6px; border-radius: 3px; display: inline-block;'
      : 'font-size: 11px; color: #666; margin-left: 5px;';
    const priceDisplay = `<span style="${priceDisplayStyle}">$${item.price.toFixed(2)} each</span>`;
    
    itemDiv.innerHTML = `
      <div class="product-img-${cartId}">
        ${item.image ? `<img src="${item.image}" width="50" height="50" alt="${item.name}">` : defaultProductImage}
      </div>
      <div class="product-info-${cartId}">
        <div class="product-name-${cartId}">
          ${item.name}
        </div>
        <div class="product-quantity-container-${cartId}" style="display: flex; align-items: center; gap: 8px; margin-top: 5px;">
          <div class="cart-quantity-selector-widget-${cartId}" style="display: flex; align-items: center; background-color: #F0F0F0; border-radius: 25px; padding: 4px; width: auto; height: auto; gap: 6px;">
            <button class="cart-quantity-btn cart-quantity-btn-minus-${cartId}" data-action="decrease" data-variant-id="${item.variantId}" style="width: 18px; height: 18px; border-radius: 50%; border: none; background-color: #8ECCF3; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; transition: background-color 0.2s ease;">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 9 2" fill="none">
                <path d="M0 0.605225H8.23137" stroke="white" stroke-width="1.21049"/>
              </svg>
            </button>
            <input type="number" class="cart-quantity-display-${cartId}" data-variant-id="${item.variantId}" value="${item.quantity}" min="1" max="999" style="flex: 1; text-align: center; font-size: 12.5px; font-weight: bold; color: #000000; border: none; background: transparent; width: 25px; padding: 0; font-family: 'Gelica bold', sans-serif;">
            <button class="cart-quantity-btn cart-quantity-btn-plus-${cartId}" data-action="increase" data-variant-id="${item.variantId}" style="width: 18px; height: 18px; border-radius: 50%; border: none; background-color: #8ECCF3; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; padding: 0; transition: background-color 0.2s ease;">
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 9 9" fill="none">
                <path d="M4.47772 0L4.47772 8.95544M0 4.47772H8.95544" stroke="white" stroke-width="1.31698"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="btn-remove-${cartId}" onclick="removeItemFromCartSnippet('${item.variantId}')">
        <svg width="24" height="24" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15.9785" cy="15.512" r="15.4062" fill="#D3D3D3"></circle>
          <path d="M9.16429 8.1438L23.9007 22.8802M23.3458 8.1438L8.60938 22.8802" stroke="white" stroke-width="2"></path>
        </svg>
      </div>
    `;
    
    // Setup quantity selector event handlers after creating the element
    setupCartQuantitySelector(itemDiv, item);
    
    return itemDiv;
  }
  
  // Function to setup quantity selector handlers for cart items
  function setupCartQuantitySelector(itemElement, item) {
    const variantId = item.variantId;
    const quantityInput = itemElement.querySelector(`.cart-quantity-display-${cartId}[data-variant-id="${variantId}"]`);
    const minusBtn = itemElement.querySelector(`.cart-quantity-btn-minus-${cartId}[data-variant-id="${variantId}"]`);
    const plusBtn = itemElement.querySelector(`.cart-quantity-btn-plus-${cartId}[data-variant-id="${variantId}"]`);
    
    if (!quantityInput || !minusBtn || !plusBtn) {
      return;
    }
    
    // Helper function to get current quantity
    function getCurrentQuantity() {
      return parseInt(quantityInput.value) || 1;
    }
    
    // Helper function to update quantity
    function updateQuantity(newQuantity) {
      if (newQuantity < 1) {
        removeItemFromCart(variantId);
        return;
      }
      
      const currentQuantity = getCurrentQuantity();
      if (newQuantity !== currentQuantity) {
        quantityInput.value = newQuantity;
        
        // Prepare item data for update
        const itemData = {
          variantId: item.variantId,
          productId: item.productId,
          name: item.name,
          image: item.image,
          price: item.price,
          quantity: newQuantity,
          sellingPlan: item.sellingPlan,
          isSubscription: item.isSubscription
        };
        
        // Update checkout cart item quantity
        updateCartItemQuantity(variantId, newQuantity, itemData);
        
        // Also update Shopify cart via UpCart
        updateShopifyCartQuantity(variantId, newQuantity, item.sellingPlan);
        
        // Update product tile quantity selector
        updateProductTileQuantitySelector(variantId, newQuantity);
      }
    }
    
    // Function to update product tile quantity selector
    function updateProductTileQuantitySelector(variantId, newQuantity) {
      // Find all elements with this variant ID (buttons, selectors, etc.)
      const variantElements = document.querySelectorAll(`[data-variant-id="${variantId}"]`);
      
      if (variantElements.length === 0) {
        return;
      }
      
      // Find the product tile container from any of these elements
      let productTileContainer = null;
      for (let i = 0; i < variantElements.length; i++) {
        const container = variantElements[i].closest('.grid-product-tile-container');
        if (container) {
          productTileContainer = container;
          break;
        }
      }
      
      if (!productTileContainer) {
        return;
      }
      
      // Find the button container and quantity selector
      const buttonContainer = productTileContainer.querySelector(`.button-container-${variantId}, .product-tile-actions-${variantId}`);
      const quantitySelector = buttonContainer?.querySelector('.quantity-selector-widget');
      
      if (quantitySelector) {
        const quantityInput = quantitySelector.querySelector('.quantity-display');
        if (quantityInput) {
          quantityInput.value = newQuantity;
        }
      }
    }
    
    // Function to update Shopify cart quantity
    function updateShopifyCartQuantity(variantId, newQuantity, sellingPlan) {
      // Get current cart to find the line item key
      fetch('/cart.js')
        .then(response => response.json())
        .then(cartData => {
          const lineItem = cartData.items.find(item => item.variant_id == variantId);
          
          if (lineItem) {
            // Update existing item using line item key
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: lineItem.key,
                quantity: newQuantity
              })
            })
            .then(response => response.json())
            .then(data => {
              // Refresh UpCart drawer
              if (window.upcartRefreshCart) {
                window.upcartRefreshCart();
              }
            })
            .catch(error => {
              console.error('Error updating Shopify cart quantity:', error);
            });
          } else {
            // Item not in cart yet, add it
            const addCartData = {
              id: variantId,
              quantity: newQuantity
            };
            
            if (sellingPlan) {
              addCartData.selling_plan = sellingPlan;
            }
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify(addCartData)
            })
            .then(response => response.json())
            .then(data => {
              // Refresh UpCart drawer
              if (window.upcartRefreshCart) {
                window.upcartRefreshCart();
              }
            })
            .catch(error => {
              console.error('Error adding item to Shopify cart:', error);
            });
          }
        })
        .catch(error => {
          console.error('Error fetching Shopify cart:', error);
        });
    }
    
    // Minus button click handler
    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentQuantity = getCurrentQuantity();
      updateQuantity(currentQuantity - 1);
    });
    
    // Plus button click handler
    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentQuantity = getCurrentQuantity();
      updateQuantity(currentQuantity + 1);
    });
    
    // Input change handler
    quantityInput.addEventListener('input', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const inputValue = parseInt(e.target.value) || 0;
      
      // Validate input
      if (inputValue < 1) {
        quantityInput.value = 1;
        updateQuantity(1);
      } else if (inputValue > 999) {
        quantityInput.value = 999;
        updateQuantity(999);
      } else {
        updateQuantity(inputValue);
      }
    });
    
    // Input blur handler (when user finishes editing)
    quantityInput.addEventListener('blur', (e) => {
      const inputValue = parseInt(e.target.value) || 1;
      if (inputValue < 1) {
        quantityInput.value = 1;
        updateQuantity(1);
      }
    });
    
    // Handle Enter key press
    quantityInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        quantityInput.blur();
      }
    });
    
    // Prevent number input spinners from appearing
    quantityInput.style.setProperty('-moz-appearance', 'textfield', 'important');
    quantityInput.style.setProperty('-webkit-appearance', 'none', 'important');
    quantityInput.style.setProperty('appearance', 'none', 'important');
    
    // Add CSS for styling to match product tile
    if (!document.getElementById('cart-quantity-input-styles-' + cartId)) {
      const style = document.createElement('style');
      style.id = 'cart-quantity-input-styles-' + cartId;
      style.textContent = `
        .cart-quantity-display-${cartId}::-webkit-outer-spin-button,
        .cart-quantity-display-${cartId}::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        .cart-quantity-display-${cartId} {
          -moz-appearance: textfield;
        }
        .cart-quantity-btn-minus-${cartId}:hover,
        .cart-quantity-btn-plus-${cartId}:hover {
          background-color: #7BB8E8 !important;
        }
        .cart-quantity-btn-minus-${cartId}:active,
        .cart-quantity-btn-plus-${cartId}:active {
          background-color: #6BA5D9 !important;
          transform: scale(0.95);
        }
      `;
      document.head.appendChild(style);
    }
    
    quantityInput.addEventListener('wheel', (e) => {
      e.preventDefault();
    });
  }
  
  // Empty slot elements are now pre-rendered from Liquid snippet
  // We just show/hide them based on cart item count
  
  // Function to handle checkout
  function handleCheckout() {
    try {
      // Refresh UpCart drawer contents if available
      if (window.upcartRefreshCart) {
        window.upcartRefreshCart();
      }
      // Prefer UpCart's open API when available
      if (window.upcartOpenCart && typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        return;
      }
      // Try clicking the theme cart button (wired to open the drawer)
      const cartBtn = document.getElementById('CartButton');
      if (cartBtn) {
        cartBtn.click();
        return;
      }
      // Fallback: dispatch a custom event many themes listen to
      const openEvent = new CustomEvent('shapes:modalcart:open');
      document.dispatchEvent(openEvent);
    } catch (e) {
      console.error('Error opening cart drawer:', e);
    }
  }
  
  // Add click event listener to checkout button(s)
  function setupCheckoutButton() {
    const checkoutButtons = document.querySelectorAll('.btn-checkout-' + cartId);
    if (checkoutButtons.length === 0) {
      return;
    }

    checkoutButtons.forEach(button => {
      button.addEventListener('click', (event) => {
        const hasItems = button.dataset.hasItems === 'true';
        if (!hasItems) {
          return;
        }

        if (button instanceof HTMLAnchorElement) {
          event.preventDefault();
        }

        handleCheckout();
      });
    });
  }
  
  // OPTIMIZED: Function to update cart item quantity with minimal logging
  function updateCartItemQuantity(variantId, newQuantity, itemData) {
    const itemIndex = cartItems.findIndex(item => item.variantId === variantId);
    if (itemIndex !== -1) {
      // Update existing item quantity
      cartItems[itemIndex].quantity = newQuantity;
      cartItems[itemIndex].name = cleanProductName(itemData.name);
      cartItems[itemIndex].image = itemData.image;
      cartItems[itemIndex].price = itemData.price;
      cartItems[itemIndex].sellingPlan = itemData.sellingPlan;
      cartItems[itemIndex].isSubscription = itemData.isSubscription;
      
      queueCartDisplayUpdate(false);
    } else {
      // Item not found, add it
      addItemToCart(itemData);
    }
  }

  // Make functions globally accessible with cart-specific names
  window['addItemToCartSnippet_' + cartId] = addItemToCart;
  window['removeItemFromCartSnippet_' + cartId] = removeItemFromCart;
  window['updateCartItemQuantity_' + cartId] = updateCartItemQuantity;
  window['updateDiscountBadgeStates_' + cartId] = updateDiscountBadgeStates;
  window['syncWithShopifyCart_' + cartId] = syncWithShopifyCart;
  window['updateToggleButtons_' + cartId] = updateToggleButtons;
  
  // Register this cart instance for UpCart callbacks (array initialized at top of file)
  window.checkoutCartInstances.push({
    cartId: cartId,
    syncFunction: syncWithShopifyCart
  });
  
  // Global add function that finds the correct cart instance
  if (!window.addItemToCartSnippet) {
    window.addItemToCartSnippet = function(itemData) {
      // Find all cart elements
      const cartElements = document.querySelectorAll('[class*="checkout-cart-sticky-"]');
      
      if (cartElements.length > 0) {
        const cartElement = cartElements[0];
        const classList = cartElement.className;
        const cartIdMatch = classList.match(/checkout-cart-sticky-([a-zA-Z0-9_-]+)/);
        
        if (cartIdMatch) {
          const cartId = cartIdMatch[1];
          if (window['addItemToCartSnippet_' + cartId]) {
            window['addItemToCartSnippet_' + cartId](itemData);
          }
        }
      }
    };
  }
  
  // Global remove function that finds the correct cart instance
  if (!window.removeItemFromCartSnippet) {
    window.removeItemFromCartSnippet = function(variantId) {
      // Find all cart elements
      const cartElements = document.querySelectorAll('[class*="checkout-cart-sticky-"]');
      
      if (cartElements.length > 0) {
        const cartElement = cartElements[0];
        const classList = cartElement.className;
        const cartIdMatch = classList.match(/checkout-cart-sticky-([a-zA-Z0-9_-]+)/);
        
        if (cartIdMatch) {
          const cartId = cartIdMatch[1];
          if (window['removeItemFromCartSnippet_' + cartId]) {
            window['removeItemFromCartSnippet_' + cartId](variantId);
          }
        }
      }
    };
  }
  
  // Global sync function to manually trigger cart sync
  if (!window.syncCheckoutCartWithShopify) {
    window.syncCheckoutCartWithShopify = function() {
      if (window.checkoutCartInstances && window.checkoutCartInstances.length > 0) {
        window.checkoutCartInstances.forEach(function(instance) {
          instance.syncFunction();
        });
      }
    };
  }
  
  // Setup checkout button
  setupCheckoutButton();
  
  // Function to sync with Shopify cart on page load
  function syncWithShopifyCart() {
    // Store current cart items before clearing (to track what was removed)
    const previousCartItems = cartItems.map(item => ({
      variantId: item.variantId,
      productId: item.productId
    }));
    
    // Set flag to prevent auto-expand during initial sync
    // Only set to true if this is the first sync (we haven't synced before)
    if (!hasSyncedBefore) {
      isInitialSync = true;
    }
    
    const cartEndpointBase = window.Shopify?.routes?.root || '/';
    const cartEndpoint = cartEndpointBase.endsWith('/')
      ? `${cartEndpointBase}cart.js`
      : `${cartEndpointBase}/cart.js`;

    fetch(cartEndpoint)
      .then(response => response.json())
      .then(cartData => {
        beginDisplayBatchUpdate();
        // Clear existing cart items before syncing to avoid duplicates
        cartItems = [];
        
        // Track which variants are currently in the cart
        const currentVariantIds = [];
        
        if (cartData.items && cartData.items.length > 0) {
          cartData.items.forEach(item => {
            // Extract variant information
            const variantId = item.variant_id;
            const productId = item.product_id;
            const quantity = item.quantity;
            const price = item.price / 100; // Convert from cents to dollars
            const sellingPlan = item.selling_plan_allocation?.selling_plan?.id || null;
            const isSubscription = !!sellingPlan;
            
            // Track this variant
            currentVariantIds.push(variantId.toString());
            
            // Build product name with variant title
            const productTitle = item.product_title || 'Product';
            const variantTitle = item.variant_title || '';
            const fullProductName = variantTitle ? `${productTitle} - ${variantTitle}` : productTitle;
            const cleanedProductName = cleanProductName(fullProductName);
            
            // Add item to checkout cart
            const itemData = {
              variantId: variantId.toString(),
              productId: productId.toString(),
              name: cleanedProductName,
              image: item.image || '',
              price: price,
              quantity: quantity,
              sellingPlan: sellingPlan,
              isSubscription: isSubscription
            };
            
            addItemToCart(itemData);
            
            // Update product grid to show quantity selector for this variant
            if (window.replaceAddToCartWithQuantitySelector) {
              setTimeout(() => {
                window.replaceAddToCartWithQuantitySelector(
                  variantId.toString(),
                  productId.toString(),
                  isSubscription,
                  sellingPlan
                );
                
                // Update the quantity display
                const productTileContainer = document.querySelector(`[data-variant-id="${variantId}"]`)?.closest('.grid-product-tile-container');
                if (productTileContainer) {
                  const buttonContainer = productTileContainer.querySelector(`.button-container-${variantId}, .product-tile-actions-${variantId}`);
                  const quantitySelector = buttonContainer?.querySelector('.quantity-selector-widget');
                  const quantityInput = quantitySelector?.querySelector('.quantity-display');
                  if (quantityInput) {
                    quantityInput.value = quantity;
                  }
                }
              }, 100);
            }
          });
        }
        
        // Find items that were removed (in previous cart but not in current cart)
        const removedItems = previousCartItems.filter(prevItem => 
          !currentVariantIds.includes(prevItem.variantId)
        );
        
        // Update product tiles for removed items - change back to "Add to Cart" button
        if (removedItems.length > 0 && window.replaceQuantitySelectorWithAddToCart) {
          removedItems.forEach(removedItem => {
            setTimeout(() => {
              window.replaceQuantitySelectorWithAddToCart(
                removedItem.variantId,
                removedItem.productId
              );
            }, 150);
          });
        }
        
        endDisplayBatchUpdate(true);
        
        // Reset initial sync flag after sync completes
        const wasInitialSync = isInitialSync;
        const wasCartEmpty = previousCartItems.length === 0;
        const cartNowHasItems = cartItems.length > 0;
        
        isInitialSync = false;
        hasSyncedBefore = true; // Mark that we've completed a sync
        
        // Auto-expand cart on mobile only when transitioning from empty to having items (but not during initial sync)
        if (!wasInitialSync && window.innerWidth <= 768 && wasCartEmpty && cartNowHasItems) {
          if (stickyCartElement?.classList.contains('cart-collapsed')) {
            stickyCartElement.classList.remove('cart-collapsed');
            updateToggleButtons(false);
          }
        }
        
        // Only force collapse on mobile if this was the initial sync AND cart is already collapsed
        // Don't close cart if user just added an item (cart would be open)
        if (wasInitialSync && window.innerWidth <= 768 && stickyCartElement) {
          // Only close if it's already collapsed (don't force close if user opened it)
          if (stickyCartElement.classList.contains('cart-collapsed')) {
            // Already collapsed, keep it that way
            updateToggleButtons(true);
          }
        }
      })
      .catch(error => {
        console.error('Error fetching Shopify cart:', error);
        endDisplayBatchUpdate(true);
        // Reset flag even on error
        const wasInitialSync = isInitialSync;
        isInitialSync = false;
        hasSyncedBefore = true; // Mark that we've attempted a sync
        
        // Only force collapse on mobile if this was the initial sync AND cart is already collapsed
        if (wasInitialSync && window.innerWidth <= 768 && stickyCartElement) {
          if (stickyCartElement.classList.contains('cart-collapsed')) {
            updateToggleButtons(true);
          }
        }
      });
  }
  
  // Initialize cart display only once after all elements are loaded
  setTimeout(() => {
    isInitialized = true; // Set flag to allow updateCartDisplay calls
    
    // On mobile, ensure cart is collapsed by default on page load
    if (window.innerWidth <= 768 && stickyCartElement) {
      stickyCartElement.classList.add('cart-collapsed');
      updateToggleButtons(true);
    }
    
    updateCartDisplay(); // Call only once after everything is loaded (includes discount tiers)
    updateToggleButtons(!!stickyCartElement?.classList.contains('cart-collapsed'));
    setupTouchDrag(); // Setup mobile touch drag functionality
    
    // Sync with Shopify cart after initialization
    syncWithShopifyCart();
    
    // Additional positioning update after elements are fully rendered
    setTimeout(() => {
      updateDiscountBadgeStates();
    }, 300);
  }, 100);
  
  // Mark as initialized (handled by caller)
  
};

// Global toggle function for mobile cart
function toggleCart(cartId) {
  const cartElement = document.querySelector('.checkout-cart-sticky-' + cartId);
  if (!cartElement) {
    return;
  }

  const toggleUpdater = window['updateToggleButtons_' + cartId];
  const arrowUp = window.checkoutCartToggleArrowUp || '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"> \
                                                         <path d="M1 11L10 2L19 11" stroke="#BDBDBD" stroke-width="1.63636"/> \
                                                       </svg>';
  const arrowDown = window.checkoutCartToggleArrowDown || '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"> \
                                                             <path d="M1 1L10 10L19 1" stroke="#BDBDBD" stroke-width="1.63636"/> \
                                                           </svg>';

  if (cartElement.classList.contains('cart-collapsed')) {
    cartElement.classList.remove('cart-collapsed');
    cartElement.classList.remove('scroll-adjusted');
    if (typeof toggleUpdater === 'function') {
      toggleUpdater(false);
    } else {
      document.querySelectorAll('.checkout-cart-sticky-' + cartId + ' .cart-toggle-' + cartId).forEach(button => {
        button.innerHTML = arrowDown;
      });
      document.querySelectorAll('.checkout-cart-fixed-' + cartId + ' .cart-toggle-' + cartId).forEach(button => {
        button.innerHTML = arrowUp;
      });
    }
  } else {
    cartElement.classList.add('cart-collapsed');
    cartElement.classList.remove('scroll-adjusted');
    if (typeof toggleUpdater === 'function') {
      toggleUpdater(true);
    } else {
      document.querySelectorAll('.checkout-cart-sticky-' + cartId + ' .cart-toggle-' + cartId).forEach(button => {
        button.innerHTML = arrowUp;
      });
      document.querySelectorAll('.checkout-cart-fixed-' + cartId + ' .cart-toggle-' + cartId).forEach(button => {
        button.innerHTML = arrowUp;
      });
    }
  }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Find all checkout cart snippet elements
  const checkoutCartSnippets = document.querySelectorAll('[class*="checkout-cart-sticky-"]');
  
  checkoutCartSnippets.forEach(function(cartElement) {
    const classList = cartElement.className;
    const cartIdMatch = classList.match(/checkout-cart-sticky-([a-zA-Z0-9_-]+)/);
    if (cartIdMatch) {
      const cartId = cartIdMatch[1];
      // Only initialize if not already initialized
      if (!window['checkoutCartSnippetInitialized_' + cartId]) {
        initCheckoutCartSnippet(cartId);
        window['checkoutCartSnippetInitialized_' + cartId] = true;
      }
    }
  });
});

// Fallback: try after a delay if no sections were found
setTimeout(function() {
  const checkoutCartSnippets = document.querySelectorAll('[class*="checkout-cart-sticky-"]');
  if (checkoutCartSnippets.length > 0) {
    checkoutCartSnippets.forEach(function(cartElement) {
      const classList = cartElement.className;
      const cartIdMatch = classList.match(/checkout-cart-sticky-([a-zA-Z0-9_-]+)/);
      if (cartIdMatch) {
        const cartId = cartIdMatch[1];
        if (!window['checkoutCartSnippetInitialized_' + cartId]) {
          initCheckoutCartSnippet(cartId);
          window['checkoutCartSnippetInitialized_' + cartId] = true;
        }
      }
    });
  }
}, 2000);